import React, { useState } from "react";
import Navbar from "./Navbar"; // Adjust the path as needed
import SideBar from "./SideBar"; // Adjust the path as needed

const DashboardLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="h-screen bg-gray-100 dark:bg-gray-900 text-xs flex flex-col m-0 p-0">
      {/* Navbar at the top */}
      <Navbar />
      {/* Content area below navbar */}
      <div className="flex flex-1 m-0 p-0">
        <SideBar collapsed={collapsed} setCollapsed={setCollapsed} />
        <main className="bg-white flex-1 p-2 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;